export const API_TRANSPORT = import.meta.env?.VITE_API_TRANSPORT === 'proxy' ? 'proxy' : 'direct'
export const PROXY_SETTINGS_KEY = 'hanjiang-helper-proxy-settings'
const pauseFallbackKey = 'hanjiang-helper-proxy-paused'
const listeners = new Set()
let cached
export const AUTO_RECOVERY_CODES = new Set(['UPSTREAM_TIMEOUT', 'UPSTREAM_NETWORK', 'PROXY_UNAVAILABLE', 'PROXY_NETWORK'])
export const canAutoRecover = settings => settings.paused && AUTO_RECOVERY_CODES.has(settings.code)

export function getProxySettings() {
  if (cached) return cached
  let value = {}
  let fallback = false
  try {
    if (typeof localStorage !== 'undefined') value = JSON.parse(localStorage.getItem(PROXY_SETTINGS_KEY) || '{}') || {}
    if (typeof sessionStorage !== 'undefined') fallback = sessionStorage.getItem(pauseFallbackKey) === '1'
  } catch { fallback = true }
  cached = { accessKey: typeof value.accessKey === 'string' ? value.accessKey : '',
    paused: Boolean(value.paused || fallback), reason: typeof value.reason === 'string' ? value.reason : '',
    code: typeof value.code === 'string' ? value.code : '', pausedAt: Number(value.pausedAt) || 0,
    nextRetryAt: 0, recovering: false }
  return cached
}

export function subscribeProxySettings(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

function notify() { for (const listener of listeners) listener() }

export function updateProxySettings(patch) {
  const next = { ...getProxySettings(), ...patch }
  // 先落盘再更新可恢复状态，存储不可用时不得假装已保存口令或解除暂停。
  localStorage.setItem(PROXY_SETTINGS_KEY, JSON.stringify(next))
  cached = next
  try { sessionStorage.removeItem(pauseFallbackKey) } catch { /* 不影响已落盘的设置 */ }
  notify()
}

export function setProxyRecoveryStatus(patch) {
  cached = { ...getProxySettings(), ...patch }
  notify()
}

export function pauseProxyExecution(reason, code = '') {
  const next = { ...getProxySettings(), paused: true, reason, code, pausedAt: Date.now(), nextRetryAt: 0, recovering: false }
  try { localStorage.setItem(PROXY_SETTINGS_KEY, JSON.stringify(next)) } catch {
    try { sessionStorage.setItem(pauseFallbackKey, '1') } catch { /* 本次页面仍保持暂停 */ }
  }
  cached = next
  notify()
}

if (typeof window !== 'undefined') {
  window.addEventListener('storage', event => {
    if (event.key !== PROXY_SETTINGS_KEY && event.key !== null) return
    cached = undefined
    getProxySettings()
    notify()
  })
}
